import { Box, Typography } from "@mui/material";
import { useResolutionsContext } from "../hooks/useResolutionsContext";

//This component is responsible for displaying the about title for a resolution event. 
export default function AboutTitle() {
    const { staticText } = useResolutionsContext();
    return (
        <Typography variant="h6" component="div" sx={{ paddingTop: 2 }}>
            <Box sx={{ fontWeight: 'bold' }}>{staticText?.AboutTitle}</Box>
        </Typography>
    );
}